import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';

import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import CardBoard from '../utility/CardBoard';

// App Classes
import Alert from '../utility/Alert';
import Typography from '@material-ui/core/Typography';

import store from '../../store_actions/StudentStore';
import * as action from '../../store_actions/StudentActions';
import Snackbar from '@material-ui/core/Snackbar';

//Tab Container
function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

// CSS Module
const styles = (theme) => ({
  root: {
    display: 'flex',
    width: '90%',
  },
  formControl: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'flex-start',
  },
  textFields: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: 10,
    paddingBottom: 5,
    paddingTop: 5,
    marginBottom: 20,
  },
  selectView: {
    paddingTop: 20,
    width: 400,
    marginLeft: 10,
  },
  selectCityView: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 20,
    width: '100%',
    marginLeft: 10,
    marginBottom: 20,
  },
  miniSelection: {
    paddingTop: 20,
    width: 220,
    marginRight: 10,
  },
  clientSelection: {
    paddingTop: 20,
    width: 320,
    marginRight: 10,
  },
  clientView: {
    paddingTop: 10,
    marginLeft: 10,
    marginRight: 10,
  },
  mapContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    height: 500,
    padding: 5,
  },
  group: {
    display: 'flex',
    flexDirection: 'column',
    width: 300,
  },
  btnPrimary: {
    backgroundColor: '#4c21af',
    width: '80%',
    alignSelf: 'center',
    borderRadius: 30,
    height: 50,
    marginTop: 30,
    marginBottom: 5,
  },
  btnLabel: {
    fontSize: 16,
    color: '#FFF',
  },
  textView: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 30,
    flexDirection: 'row',
    backgroundColor: '#FFF',
    alignSelf: 'center',
    height: 48,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 5,
    paddingBottom: 10,
    marginTop: 10,
    marginBottom: 10,
    width: 300,
  },

  login: {
    flexDirection: 'column',
    display: 'flex',
    marginTop: window.innerHeight / 10,
    width: 400,
    justifyContent: 'center',
    alignItems: 'center',
  },
});

class AdminUser extends React.Component {
  constructor(props) {
    super(props);
    this.makeChanges = this.makeChanges.bind(this);
    this.state = {
      generate_number: 10,
      email: '',
      password: '',
      open: false,
    };
  }

  componentWillMount() {
    store.on('change', this.makeChanges);
  }

  makeChanges() {
    const { loading, generated } = store.generatedStatus();
    this.setState({
      loading: loading,
      generated: generated,
    });
    this.setState({
      open: true,
    });
    setTimeout(() => {
      this.setState({
        open: false,
      });
    }, 3000);
  }

  onTapBack = () => {
    this.props.onTapBack();
  };

  onTapAddNewTask() {
    const { generate_number } = this.state;
    action.GenerateLogin({ qty: generate_number });
  }

  onCreateAdminUser = () => {
    alert('User Created!');
  };

  render() {
    const { classes } = this.props;
    const { generated, title, msg, value } = this.state;

    return (
      <div>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.open}
          autoHideDuration={4000}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={
            <span id="message-id" style={{ color: 'green' }}>
              {'Created Admin User'}
            </span>
          }
        ></Snackbar>
        <Grid container direction="row" justify="center" alignItems="center">
          <div className={classes.login}>
            <label
              style={{
                fontSize: 20,
                alignSelf: 'center',
                color: '#505050',
                marginTop: 20,
                marginBottom: 20,
              }}
            >
              Create Admin User
            </label>
            <div className={classes.textView}>
              <TextField
                onChange={(e) => {
                  this.setState({ email: e.target.value });
                }}
                style={{ width: '100%', display: 'flex' }}
                placeholder="Email ID"
                InputProps={{ disableUnderline: true }}
              />
            </div>

            <div className={classes.textView}>
              <TextField
                onChange={(e) => {
                  this.setState({ password: e.target.value });
                }}
                style={{ width: '100%', display: 'flex' }}
                placeholder="Password"
                InputProps={{ disableUnderline: true }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    this.onCreateAdminUser();
                  }
                }}
              />
            </div>

            <Button
              className={classes.btnPrimary}
              onClick={() => this.onCreateAdminUser()}
            >
              <label className={classes.btnLabel}>Create</label>
            </Button>
          </div>
        </Grid>
      </div>
    );
  }
}

AdminUser.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(AdminUser);
